import AdminUpdatePasein from "../../components/AdminModules/AdminModulesUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
